import React from 'react';
import Typography from 'style-guide/component/Typography';
import Button from 'style-guide/component/Button';
import { DeleteModalProps } from '../types/questionTypes';

const DeleteModal: React.FC<DeleteModalProps> = ({
  visible,
  file,
  uploadedFile,
  deleteModalType,
  isDelete,
  deleteError,
  onConfirm,
  onCancel,
}) => {
  if (!visible) return null;

  const fileName = deleteModalType === 'uploaded' 
    ? uploadedFile?.display_name 
    : file?.name;

  return (
    <>
      {/* Overlay to block interaction and darken background */}
      <div
        className="fixed inset-0 z-[9998] bg-black bg-opacity-60"
        style={{ pointerEvents: "auto" }}
        aria-hidden="true"
      />
      <div className="w-[400px] fixed bg-white border border-gray-300 shadow-md p-4 rounded-lg z-[9999] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col gap-6">
        <Typography
          text={`Are you sure you want to delete "${fileName}"?`}
          variant="LG"
        />
        {deleteError && <div className="text-red-500">{deleteError}</div>}
        <div className="flex flex-row gap-2 justify-end">
          <Button
            type={isDelete ? "Disabled" : "Default"}
            buttonText="Cancel"
            onClick={onCancel}
          />
          <Button
            type={isDelete ? "Disabled" : "Primary"}
            buttonText={isDelete ? "Deleting..." : "Delete"}
            onClick={onConfirm}
          />
        </div>
      </div>
    </>
  );
};

export default DeleteModal;
